module.exports = __webpack_public_path__ + "static/media/trash-icon-red.c1510f98.svg";